import { render, staticRenderFns } from "./EventosDestacadosCarousel.vue?vue&type=template&id=c42d1cec&scoped=true&"
import script from "./EventosDestacadosCarousel.vue?vue&type=script&lang=js&"
export * from "./EventosDestacadosCarousel.vue?vue&type=script&lang=js&"
import style0 from "./EventosDestacadosCarousel.vue?vue&type=style&index=0&id=c42d1cec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c42d1cec",
  null
  
)

export default component.exports